export default "__VITE_ASSET__BOXCzyUr__"